import { resolveTypingDelayMs, type TypingDelayChannel } from '@coaching/api/lib/typing-delay.js';

export interface TypingDelayBotSettings {
  typingDelayMs?: number | null;
  integrations?: {
    whatsapp?: {
      enabled?: boolean | null;
    } | null;
  } | null;
}

export interface PendingAssistantMessage {
  id: string;
  role: 'assistant';
  content: string;
  timestamp: Date;
  isStreaming: true;
  showTypingIndicator: boolean;
  messageType: 'text' | 'voice';
}

export function resolveTestBotTypingDelayMs(
  botDetails?: TypingDelayBotSettings | null,
  activeChannel: TypingDelayChannel = 'other'
): number {
  if (!botDetails?.integrations?.whatsapp?.enabled) return 0;
  return resolveTypingDelayMs(botDetails.typingDelayMs, activeChannel);
}

export function resolveTestBotTypingDelayChannel(
  hasCurrentSession = false,
  sessionPlatform?: string | null
): TypingDelayChannel {
  if (!hasCurrentSession) return 'other';
  return sessionPlatform === 'whatsapp' ? 'whatsapp' : 'other';
}

export function createPendingAssistantMessage(
  messageId: string,
  timestamp: Date,
  messageType: 'text' | 'voice',
  typingDelayMs: number
): PendingAssistantMessage {
  return {
    id: messageId,
    role: 'assistant',
    content: '',
    timestamp,
    isStreaming: true,
    showTypingIndicator: typingDelayMs === 0,
    messageType,
  };
}
